var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotDecided(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.377 3.33325C32.719 3.33325 30.6576 7.45613 30.6576 10.2194V10.614C30.6576 11.0965 31.0523 11.4474 31.491 11.4474H33.9034C34.3858 11.4474 34.7368 11.0528 34.7368 10.614V10.2194C34.7368 10.0878 34.7805 7.41235 38.3771 7.41235C40.7017 7.41235 41.7104 8.28946 41.7104 10.3072C41.7104 11.623 40.1751 12.9826 38.7718 14.1669C36.8419 15.7458 35.9211 17.4126 35.9211 19.2984L35.9207 20.2193C35.9207 20.7018 36.3154 21.0528 36.7542 21.0528H39.1665C39.649 21.0528 39.9999 20.6581 39.9999 20.2193V19.2981C39.9999 19.0788 39.9999 18.4647 41.3595 17.3245C43.0262 15.965 45.8332 13.6842 45.8332 10.3068C45.7892 6.92989 43.8596 3.33325 38.3772 3.33325H38.377Z",
    fill: "#F59E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6579 25.5262C40.6579 26.9797 39.4797 28.1579 38.0265 28.1579C36.573 28.1579 35.3948 26.9797 35.3948 25.5262C35.3948 24.073 36.573 22.8948 38.0265 22.8948C39.4797 22.8948 40.6579 24.073 40.6579 25.5262Z",
    fill: "#F59E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7193 17.9384C27.7193 22.5165 24.3222 26.2278 20.1317 26.2278C15.9409 26.2278 12.5441 22.5165 12.5441 17.9384C12.5441 13.3603 15.9409 9.64893 20.1317 9.64893C24.3222 9.64893 27.7193 13.3603 27.7193 17.9384Z",
    fill: "#F59E0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7806 28.5963L27.2368 27.4561C25.2632 29.0788 22.807 30.0878 20.1316 30.0878C17.4562 30.0878 15 29.1229 13.0264 27.4561L10.4826 28.5963C7.14932 30.0875 5.00012 33.421 5.00012 37.1051V41.5788C5.00012 43.4646 6.53536 44.9999 8.42117 44.9999H31.886C33.7718 44.9999 35.3071 43.4646 35.3071 41.5788L35.3068 37.1051C35.263 33.421 33.1139 30.1315 29.7806 28.5963Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotDecided);
export default __webpack_public_path__ + "static/media/NotDecided.0e9906dd398b616c81285243c1328068.svg";
export { ForwardRef as ReactComponent };